var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFeatherCheckCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 99 98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .a,\n            .b,\n            .d {\n                fill: none;\n            }\n\n            .a,\n            .b {\n                stroke: #fff;\n                stroke-linecap: round;\n                stroke-width: 4px;\n            }\n\n            .a {\n                stroke-linejoin: round;\n            }\n\n            .b {\n                stroke-dasharray: 231;\n            }\n\n            .c {\n                stroke: none;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.796 0.121)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M73.514,6,27.349,52.211,13.5,38.362",
    transform: "translate(21.377 5.974)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(94.204 3.879) rotate(90)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 45,
    cy: 45.5,
    rx: 45,
    ry: 45.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 45,
    cy: 45.5,
    rx: 47,
    ry: 47.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeatherCheckCircle);
export default __webpack_public_path__ + "static/media/Icon_feather_check_circle.438e0bfd.svg";
export { ForwardRef as ReactComponent };